import { render, staticRenderFns } from "./termSchedule.vue?vue&type=template&id=f2813e22"
import script from "./termSchedule.vue?vue&type=script&lang=js"
export * from "./termSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports